import { palette } from "../../../../palette";

const styles = {
  root: {
    display: 'flex',
  },
  cardHeader: {
    display: 'flex',
    width: '100%',
    overflowWrap: 'break-word', // Changed from 'normal'
    fontWeight: 'bold',
    wordBreak: 'break-word', // Added to ensure long words break properly
    whiteSpace: 'normal', // Changed from default
    overflow: 'visible', // Changed from default
  },
  cardTitleIcon: {
    display: 'inline',
    width: '44px',
    marginRight: '5px',
    height: '44px',
    flexShrink: 0, // Prevent icon from shrinking
  },
  cardTitleRow: {
    display: 'flex',
    alignItems: 'flex-start', // Changed from center to allow better text wrapping
    marginBottom: '5px',
  },
  dateTimePicker: {
    marginRight: '30px',
  },
  description: {
    overflowWrap: 'break-word',   
    whiteSpace: 'normal',         
    wordBreak: 'break-word',      
    width: '100%',                
    textOverflow: 'clip',        // Changed from 'ellipsis' to show all content
    overflow: 'visible',         // Changed from 'hidden' to show all content
    display: 'block',             
    lineHeight: 1.5,              
    maxHeight: 'none',           // Changed from '3.6em' to remove height restriction
  },
  divider: {
    minWidth: '150px',
  },
  dividerWeekend: {
    minWidth: '150px',
    marginTop: -20,
  },
  inlineIcon: {
    height: 30,
    width: 30,
    marginLeft: 5,
    marginBottom: -4,
  },
  priceText: {
    textAlign: 'right',
    color: 'black',
    paddingTop: '5px',
    fontWeight: 'bold',
  },
  quickSelectRow: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    gap: '16px',
  },
  radio: {
    display: 'inline',
  },
  warningBannerBox: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f8d7d9',
    marginBottom: 4,
    border: '1px solid #f5c2c7',
    borderRadius: 4,
  },
  // Added new styles for card components
  optionCard: {
    height: 'auto',
    minHeight: '200px',
    borderRadius: 10,
    padding: '15px',
    display: 'flex',
    flexDirection: 'column',
  },
  optionCardSelected: {
    borderColor: "#337AB7",
    borderWidth: 4,
    backgroundColor: "#337AB720"
  },
  optionCardContent: {
    height: '100%',
    display: 'flex', 
    flexDirection: 'column',
    padding: 0
  },
  optionCardText: {
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    overflow: 'visible'
  }
};

export default styles;